module.exports = __webpack_public_path__ + "static/media/img-08.b6e7d301.png";